import { setAsyncData } from '../core';
import { ServiceOfferingState } from './types';

import { ServiceOfferingActions } from './actions';

const initialState: ServiceOfferingState = {
  services: { isFetching: false },
};

export function serviceOfferingReducer(state: ServiceOfferingState = initialState, action: ServiceOfferingActions): ServiceOfferingState {
  switch (action.type) {
    case 'SERVICE_OFFERING_SET_IS_FETCHING':
      return {
        ...state,
        services: setAsyncData(state.services, (v) => (v.isFetching = action.data)),
      };

    case 'SERVICE_OFFERING_SET_SERVICE_OFFERING':
      return {
        ...state,
        services: setAsyncData(state.services, (v) => (v.data = action.data)),
      };
    default:
      return state;
  }
}
